import { StatusPill } from "@/components/ui/status-pill";
import { capitalize } from "@/lib/format";
import { statusTone } from "@/lib/status-tone";

interface StatusBadgeProps {
  className?: string;
  status: string | null | undefined;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <StatusPill className={className} tone={statusTone(status)}>
      {capitalize(status)}
    </StatusPill>
  );
}
